__turbopack_context__.v({
  "category-entries": "_7_zIjG_category-entries",
  "category-entries__icon": "_7_zIjG_category-entries__icon",
  "category-entries__icon--left": "_7_zIjG_category-entries__icon--left",
  "category-entries__icon--right": "_7_zIjG_category-entries__icon--right",
  "category-entries__link": "_7_zIjG_category-entries__link",
  "category-entries__list-item--parent": "_7_zIjG_category-entries__list-item--parent",
  "category-entries__sub-list": "_7_zIjG_category-entries__sub-list",
  "category-entries__sub-list--with-children": "_7_zIjG_category-entries__sub-list--with-children",
  "category-entries__sub-list__list-item": "_7_zIjG_category-entries__sub-list__list-item",
  "category-entries__sub-list__list-item--closed": "_7_zIjG_category-entries__sub-list__list-item--closed",
});
